jQuery(document).ready(function ($) {
	class TrexInpageNav {
		constructor() {
			this.body = $('body');
			this.main = $('main');
			this.header = this.body.find('.main-header');
			this.alertBar = this.body.find('.alert-bar');
			this.hero = this.main.find('section').first();
			this.nav = this.main.find('.trex-inpage-nav');
			this.navigationMenu = this.nav.find('.inpage-nav__list');
			this.sections = this.main.find('section, .block-hook');
			this.sectionsArr = [];
			this.mobileBtn = this.body.find('.inpage-nav__mobile-toggle');
			this.mobileBtnSet = 0;
		}

		init() {
			this.generateLinks();
			this.navigationMenu.on(
				'click',
				'.inpage-nav__link',
				this.navLinkClick.bind(this)
			);
			this.stickNav();

			// if this.navigationMenu is empty, hide the inpage nav
			if (this.navigationMenu.children().length === 0) {
				this.nav.hide();
			}

			this.mobileBtn.on('click', this.mobileNavClick);

			$(window).on('scroll', this.scrollSpy);
		}

		generateLinks() {
			this.sections.each((index, el) => {
				const id = $(el).attr('id');

				if (
					id &&
					id.toLowerCase().indexOf('page-block-') === -1 &&
					id.toLowerCase().indexOf('hero') === -1
				) {
					const link = id.replaceAll(' ', '-');
					let title = id.replace('block-trex-', ' ');
					title = title.replaceAll('-', ' ');
					if ( 'cta' === title.trim() ) {
						title = 'join';
					}
					const element = `<li class="inpage-nav__list-item"><a class="inpage-nav__link" href="#${link}">${title}</a></li>`;
					this.navigationMenu.append(element);

					if (this.mobileBtnSet === 0) {
						this.mobileBtnSet = 1;
						this.mobileBtn.append(
							`<span>${title}</span><span class='icon-drop-down'></span>`
						);
					}
				}
			});
		}

		navLinkClick(e) {
			const element = $(e.target);
			this.navigationMenu.find('.inpage-nav__link').removeClass('active');
			element.addClass('active');
			this.mobileBtn.empty();
			this.mobileBtn.append(
				`<span>${element.text()}</span><span class='icon-drop-down'></span>`
			);
			//if mobile menu is open, close it
			if (this.mobileBtn.hasClass('open')) {
				this.mobileBtn.removeClass('open');
				this.nav.find('.inpage-nav__wrapper').slideUp();
			}
		}

		stickNav() {
			let top = 0;
			if (this.alertBar.length != 0) {
				top = top + this.alertBar.outerHeight();
			}
			if (this.header.length != 0) {
				top = top + this.header.outerHeight();
			}
			this.nav.css({ top });
		}

		scrollSpy() {
			const sections = $('section'),
				nav = $('.trex-inpage-nav'),
				navHeight = nav.outerHeight(),
				mobileBtn = nav.find(
					'.inpage-nav__mobile-toggle span:first-child'
				);
			let header = $('.main-header'),
				headerHeight = 0;
			let alertBar = $('.alert-bar'),
				alertBarHeight = 0;
			if (alertBar.length != 0) {
				alertBarHeight = alertBar.outerHeight();
			}
			if (header.length != 0) {
				headerHeight = header.outerHeight();
			}
			let timer;
			$(window).on('scroll', function () {
				if (timer) {
					window.clearTimeout(timer);
				}
				timer = window.setTimeout(function () {
					const curPos = $(this).scrollTop();
					sections.each(function () {
						const top =
								$(this).offset().top -
								navHeight -
								alertBarHeight -
								headerHeight -
								100,
							bottom = top + $(this).outerHeight();
						if (curPos >= top && curPos <= bottom) {
							nav.find('.inpage-nav__link').removeClass('active');
							const curLink = nav.find(
								'.inpage-nav__link[href="#' +
									$(this).attr('id') +
									'"]'
							);
							const text = curLink.text();
							if (text) {
								mobileBtn.text(text);
							}
							curLink.addClass('active');
						}
					});
				}, 25);
			});
		}

		mobileNavClick(e) {
			$(this).toggleClass('open');
			$(this).next().stop().slideToggle(250);
		}
	}

	const blockTrexInpageNav = new TrexInpageNav();
	blockTrexInpageNav.init();
});
